import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { setRepresentativeSignature } from '../store/signatures.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getAuthorizedRepresentativeSignature() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const pcr: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcr._attachments) {
      if (pcr._attachments.StandardSignatures_Section2_Representative !== undefined) {
        const authorizedRepresentativeSignature = pcr._attachments.StandardSignatures_Section2_Representative
        const signature = document.createElement('img')
        signature.src =
          'data:' +
          authorizedRepresentativeSignature.fileExtension +
          ';base64,' +
          authorizedRepresentativeSignature.data
        yield put(setRepresentativeSignature(signature.src))
      } else {
        yield put(setRepresentativeSignature(null))
      }
    } else {
      yield put(setRepresentativeSignature(null))
    }
  } catch (e) {
    yield put(throwPcrException(`getAuthorizedRepresentativeSignature() error: ${e}`))
  }
}

export function* getAuthorizedRepresentativeSignatureSaga() {
  yield takeLatest([SignaturesConstants.GET_SIGNATURES], performWithMutexHOG, getAuthorizedRepresentativeSignature)
}
